

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { DropDownMeta } from 'src/app/shared/model/base-model';
import { ScClaim, ScClaimItem, ScClaimList, ScClaimUpdateInput } from './sc-claim.model';

@Injectable({
    providedIn: 'any'
})

export class ScClaimService{

    private environmentUrl: string = '';

    constructor(private httpClient: HttpClient)
    {
        this.environmentUrl = environment.ApiCore+'/Claim/';
    }

    getItem(id: string): Observable<ScClaimItem> {
        let url = this.environmentUrl + id;
        return this.httpClient.get<ScClaimItem>(url);
    }

    getList(): Observable<ScClaimList> {
        let url = this.environmentUrl;
        return this.httpClient.get<ScClaimList>(url);
    }

    addItem(model: ScClaim) {
        return this.httpClient.post(this.environmentUrl, model);
    }

    updItem(model: ScClaim, userId: string) {

        let url = this.environmentUrl + model.id;
        let modelUpd: ScClaimUpdateInput = {};

        modelUpd.id = model.id;
        modelUpd.code = model.code;
        modelUpd.name = model.name;
        modelUpd.icon = model.icon;
        modelUpd.color = model.color;
        modelUpd.isActive = model.isActive;
        modelUpd.userId = userId;

        return this.httpClient.put(url, modelUpd);
    }

    delItem(id: string) {
        return this.httpClient.delete(this.environmentUrl + id);
    }

    getDropDownList(): Observable<DropDownMeta> {
        let url = this.environmentUrl + "DropDown";
        return this.httpClient.get<DropDownMeta>(url);
    }

}
